import type { Theme } from '@ori-ui/mui';
import { useTheme } from '@ori-ui/mui';
import { useMemo } from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';

const get = (title: string, palette: Theme['palette']) => {
  switch (title) {
    case 'accessories':
      return { backgroundColor: palette.red[50], color: palette.yellow[400] };
    case 'bath-body':
    case 'body-care':
      return { backgroundColor: palette.blue[100], color: palette.info.dark };
    case 'essential-oils':
      return {
        backgroundColor: palette.purple[50],
        color: palette.purple[400],
      };
    case 'fragrance':
      return { backgroundColor: palette.brown[50], color: palette.brown[400] };
    case 'hair':
      return {
        backgroundColor: palette.yellow[50],
        color: palette.yellow[400],
      };
    case 'kids-baby':
      return { backgroundColor: palette.blue[50], color: palette.info.dark };
    case 'makeup':
      return { backgroundColor: palette.pink[50], color: palette.pink[300] };
    case 'men':
      return {
        backgroundColor: palette.primary.light,
        color: palette.secondary.main,
      };
    case 'personal-products-list':
      return {
        backgroundColor: palette.secondary.light,
        color: palette.common.white,
      };
    case 'skincare':
      return {
        backgroundColor: palette.primary.light,
        color: palette.green[400],
      };
    case 'wellness':
      return {
        backgroundColor: palette.purple[200],
        color: palette.purple[400],
      };
    default:
      return undefined;
  }
};

export const useCategoryColors = () => {
  const { categoryTitle } = useTopAreaStore();
  const { palette } = useTheme();

  return useMemo(() => get(categoryTitle, palette), [categoryTitle, palette]);
};
